import { Component, Input } from "@angular/core";

@Component({
    standalone: true,
    selector: 'gene-broken-image-icon',
    templateUrl: './broken-image-icon.component.html',
    styleUrls: ['./broken-image-icon.component.css']
})
export class BrokenImageIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;
};
